import { ClipboardListIcon, DropletIcon, TrendingUpIcon, DumbbellIcon, RefreshCwIcon, type LucideIcon } from "lucide-react";

export type Bonus = {
  number: string;
  title: string;
  description: string;
  listTitle: string;
  items: string[];
  closing: string[];
  icon: LucideIcon;
  color: string;
  value: number;
};

export const bonuses: Bonus[] = [
  {
    number: "01",
    title: "40 Printable Weekly Training Sheets",
    description: "One ready-to-use coaching sheet for every week of pregnancy.",
    listTitle: "Includes",
    items: ["Workout A", "Workout B", "Workout C", "Exercises", "Sets", "Reps", "Rest", "RPE", "Main Modifications", "Coach Notes"],
    closing: ["Print.", "Coach.", "Record."],
    icon: ClipboardListIcon,
    color: "#1C2F4F",
    value: 15,
  },
  {
    number: "02",
    title: "Active Pregnancy Fuel & Hydration Reference",
    description: "Practical training-day reference for:",
    listTitle: "Covers",
    items: ["Hydration", "Pre-training energy", "Long gaps without eating", "Training-day nausea", "Hot environments", "Recovery", "Fatigue", "Session adjustments"],
    closing: ["Check.", "Adjust.", "Refer."],
    icon: DropletIcon,
    color: "#4A7556",
    value: 15,
  },
  {
    number: "03",
    title: "Initial Assessment & Client Progress Tracker",
    description: "Professional forms to track:",
    listTitle: "Tracks",
    items: ["Loads", "Sets", "Reps", "Rest", "RPE", "Exercise Variations", "Modifications", "Energy", "Range Changes", "Support Needs", "Session Response"],
    closing: ["Assess.", "Record.", "Track."],
    icon: TrendingUpIcon,
    color: "#1F6B73",
    value: 15,
  },
  {
    number: "04",
    title: "120-Exercise Prenatal Training Library",
    description: "120 organized exercises and variations.",
    listTitle: "Categories",
    items: ["Squats", "Hip Hinges", "Split Stance", "Glutes", "Upper-Body Pull", "Upper-Body Push", "Core", "Stability", "Carries", "Mobility", "Low-Impact Conditioning"],
    closing: ["Find.", "Compare.", "Coach."],
    icon: DumbbellIcon,
    color: "#B4676B",
    value: 15,
  },
  {
    number: "05",
    title: "Visual Exercise Adaptations Through Pregnancy",
    description: "Show how exercises can be modified through:",
    listTitle: "Modified through",
    items: ["Stance", "Range", "Load Position", "External Support", "Starting Height", "Body Position", "Exercise Variation"],
    closing: ["Same training goal.", "Different execution as the body changes."],
    icon: RefreshCwIcon,
    color: "#2D3033",
    value: 15,
  },
];
